import { render, staticRenderFns } from "./CartPositionItem.vue?vue&type=template&id=68a97908&"
import script from "./CartPositionItem.vue?vue&type=script&lang=ts&"
export * from "./CartPositionItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports